import React, { useState, useEffect } from "react";
import ReactFlow, { Background, Controls } from "reactflow";
import "reactflow/dist/style.css";

const PipelineFlow = ({ pipelineData }) => {
  const [elements, setElements] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Extract pipeline data from the URL
    const params = new URLSearchParams(window.location.search);
    const dataString = params.get("data");

    if (!dataString) {
      setError("No pipeline data found in the URL.");
      return;
    }

    const pipelineData = JSON.parse(decodeURIComponent(dataString));
    console.log(pipelineData)
    if (!pipelineData || typeof pipelineData !== "object") {
      setError("Invalid pipeline data.");
      return;
    }

    const newElements = [];
    let yPos = 50;
    let xPos = 300;
    let prevNode = "input";

    // Root node
    newElements.push({ id: "input", data: { label: "Input Data" }, position: { x: xPos, y: yPos } });
    
    // Loop through JSON stages
    Object.entries(pipelineData).forEach(([stage, details], index) => {
      yPos += 100;
      const stageId = `stage-${index}`;
      console.log('stageId') 
      console.log(stageId) 
      let label = stage.charAt(0).toUpperCase() + stage.slice(1); // Capitalize first letter

      // Handle different types of stage details
      if (typeof details === "string") {
        label += ` (${details})`; // Example: Summarization (summarization)
      } else if (typeof details === "object") {
        if (details.model) label += ` [Model: ${details.model}]`; // Example: NER [Model: BioClinicalBERT]
        if (details.enabled !== undefined) label += ` [${details.enabled ? "Enabled" : "Disabled"}]`;
      }

      newElements.push({ id: stageId, data: { label }, position: { x: xPos, y: yPos } });
      newElements.push({ id: `e-${prevNode}-${stageId}`, source: prevNode, target: stageId });

      prevNode = stageId;
    });

    // Output node
    yPos += 100;
    newElements.push({ id: "output", data: { label: "Output Data" }, position: { x: xPos, y: yPos } });
    newElements.push({ id: `e-${prevNode}-output`, source: prevNode, target: "output" });

    setElements(newElements);
  }, [pipelineData]);

  return (
    <div style={{ width: "100%", height: "500px", background: "#f9f9f9", borderRadius: "10px", padding: "10px" }}>
      <ReactFlow elements={elements} fitView>
        <Background />
        <Controls />
      </ReactFlow>
    </div>
  );
};

export default PipelineFlow;
